import { Tooltip } from '@fountain/ripple/tooltip';
import React, { useId } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';

import { useStyles } from './styles';

/**
 * The next step for something that blocks the request, on hover and on focus.
 *
 * The trigger takes focus and nothing else. It is no control: the step is for
 * someone who may manage approval rules. A screen reader hears the step as the
 * trigger's description, because the tooltip itself is not announced. The
 * queue's status cell and the review panel's rail both use it.
 */
export const NextStep: React.FC<
  React.PropsWithChildren<{ step: MessageDescriptor }>
> = ({ step, children }) => {
  const styles = useStyles();
  const intl = useIntl();
  const descriptionId = useId();
  const text = intl.formatMessage(step);

  return (
    <Tooltip>
      <Tooltip.Trigger
        render={
          <span
            aria-describedby={descriptionId}
            className={styles.tooltipTrigger}
            tabIndex={0}
          />
        }
      >
        {children}
      </Tooltip.Trigger>
      <span hidden id={descriptionId}>
        {text}
      </span>
      <Tooltip.Content
        align="start"
        positionerClassName={styles.tooltipPositioner}
        side="bottom"
        size="md"
      >
        {text}
      </Tooltip.Content>
    </Tooltip>
  );
};
